import styled from "@emotion/styled";
import { AddCircle } from "@mui/icons-material";
import {
    Breadcrumbs,
    Typography,
    type Theme
} from "@mui/material";
import { Link } from "react-router-dom";

const StyledLink = styled(Link)(({ theme }) => ({
    color: contrastText(theme as Theme),
    textDecoration: "none",
    display: "flex",
}));

const StyledTypography = styled(Typography)(
    ({ theme }) => ({ color: (theme as Theme).palette.primary.main, display: "flex" }),
);

export const Breadcrumb = ({ name, view ,hasCreate }: { name: string, view: string, hasCreate?: boolean }): JSX.Element => {
    return <Breadcrumbs
        aria-label="breadcrumb"
        sx={(t: Theme) => ({
            paddingLeft: 1,
            color: t.palette.secondary.main,
            flexWrap: "nowrap",
            flex: 1
        })}
    >
        {name && name !== "shop" &&
            (view ? (
                <StyledLink to={`/${name}`} aria-label={name}>
                    <StyledTypography
                        variant="h5"
                        sx={{ textTransform: "capitalize" }}
                    >
                        {name}
                    </StyledTypography>
                </StyledLink>
            ) : (
                <StyledTypography
                    variant="h5"
                    sx={{ textTransform: "capitalize" }}
                >
                    {name}
                </StyledTypography>
            ))}
        {view ? (
            <StyledTypography
                variant="h5"
                sx={{ textTransform: "capitalize" }}
            >
                {decodeURI(view)}
            </StyledTypography>
        ) : (hasCreate || name === "stock") ? (
            <StyledLink
                to={`/${name === "stock" ? "order" : name}/create`}
                aria-label="Create"
            >
                <AddCircle
                    sx={t => ({ fontSize: "1.1rem", marginTop: "3px", color: t.palette.primary.main })} />
            </StyledLink>
        ) : undefined}
    </Breadcrumbs>;
};

export const contrastText = (t: Theme): string => t.palette.getContrastText(t.palette.primary.main);